import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "./sass/reset.scss";
import "vant/lib/index.css";

Vue.use(Vuex);

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
Vue.use(Loading);

import vueHeadful from "vue-headful";
import { Toast, Col, Row, Uploader } from "vant";
Vue.component("vue-headful", vueHeadful);

Vue.use(Uploader);
Vue.use(Col);
Vue.use(Row);

import VueAwesomeSwiper from "vue-awesome-swiper";

// import style (>= Swiper 6.x)
// import 'swiper/swiper-bundle.css'
import "swiper/css/swiper.css";
Vue.use(VueAwesomeSwiper /* { default options with global component } */);

axios.interceptors.request.use(
  (config) => {
    config.baseURL = "";
    var token = localStorage.getItem("spx-token");
    // var token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9sb2NhbGhvc3QiLCJpYXQiOjE2MjMzOTIyMTcsImV4cCI6MTYyNDYwMTgxNywibmJmIjoxNjIzMzkyMjE3LCJqdGkiOiJrcVc4OEFLRzF4ZE1VVGNLIiwic3ViIjoxLCJwcnYiOiI4N2UwYWYxZWY5ZmQxNTgxMmZkZWM5NzE1M2ExNGUwYjA0NzU0NmFhIn0.-U7yXkm7AeAtsGZiH1dSFQPdFla1-mv5GpcyrZDEqp0'
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    const res = response;
    if (response.status === 200) {
      return res;
    } else {
      if (response.status === 401) {
        localStorage.removeItem("spx-token");
        const url = encodeURIComponent(location.href);
        let appId = "wxa835709a6a52c7bc";
        location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=123456#wechat_redirect`;
      } else {
        if (res.msg) {
          alert(res.msg);
        }
      }
      return Promise.reject(res);
    }
  },
  (error) => {
    if (error.response ? error.response.status == 401 : false) {
      localStorage.removeItem("spx-token");
      const url = encodeURIComponent(location.href);
      let appId = "wxa835709a6a52c7bc";
      location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=123456#wechat_redirect`;
    } else {
      Toast.fail(error.message.indexOf("timeout") > -1 ? "请求超时" : "验证失败，请检查您的输入");
      return Promise.reject(error);
    }
  }
);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
